`use strict`;

class Draad_Nav_Menu {

    constructor(domNode) {

        this.rootEl = domNode;
        this.toggleNode = this.rootEl.querySelector('.navigation__toggle');
        this.menuItems = Array.from(this.rootEl.querySelectorAll('.navigation__item'));

		const subMenus = Array.from(this.rootEl.querySelectorAll('.navigation__submenu-wrapper'));
		subMenus.forEach((subMenu) => {
			
			const parentPosition = subMenu.parentElement.getBoundingClientRect();

			// check if submenu fits on screen aligned from te left site of the parent menu item
			const fitsOnScreenLeft = parentPosition.left + subMenu.offsetWidth < window.innerWidth - 80;
			const fitsOnScreenRight = parentPosition.right - subMenu.offsetWidth > 80;
			const fitsOnScreenCenter = parentPosition.left + (subMenu.offsetWidth / 2) < window.innerWidth - 80 && parentPosition.right - (subMenu.offsetWidth / 2) > 80;

			if ( fitsOnScreenLeft ) {
				subMenu.classList.add('--left');
			} else if ( fitsOnScreenRight ) {
				subMenu.classList.add('--right');
			} else if ( fitsOnScreenCenter ) {
				subMenu.classList.add('--center');
			} else {
				subMenu.classList.add('--full');
			}

		});

        this.addMenuItemsHandlers();
    }

    focusContainer = null;

    responsive = null;

    addMenuItemsHandlers() {

        this.checkBreakpoint();
        window.addEventListener('resize', () => { this.checkBreakpoint() });

        this.toggleNode.addEventListener('click', () => { this.toggleMenu() });

        this.menuItems.forEach((item) => {

            const button = item.querySelector(':scope > button');
            const subMenu = item.querySelector(':scope > .navigation__submenu-wrapper');

            if (!button || !subMenu) {
                return;
            }

            button.addEventListener('click', () => {

                const expanded = button.getAttribute('aria-expanded') === 'true';
                this.closeAllSubMenus(item);

                if (expanded) {
                    button.setAttribute('aria-expanded', 'false');
                    subMenu.setAttribute('aria-hidden', 'true');
                    subMenu.setAttribute('hidden', 'hidden');
                } else {
                    button.setAttribute('aria-expanded', 'true');
                    subMenu.setAttribute('aria-hidden', 'false');
                    subMenu.removeAttribute('hidden');
                }

            });

            if ( window.matchMedia('(pointer: fine)').matches ) {
                item.addEventListener('mouseover', () => {

                    button.setAttribute('aria-expanded', 'true');
                    subMenu.setAttribute('aria-hidden', 'false');
                    subMenu.removeAttribute('hidden');

                });

                item.addEventListener('mouseout', (event) => {

                    button.setAttribute('aria-expanded', 'false');
                    subMenu.setAttribute('aria-hidden', 'true');
                    subMenu.setAttribute('hidden', 'hidden');

                });
            }

            item.addEventListener('focusout', (event) => {

                if (item.contains(event.relatedTarget)) {
                    return;
                }

                button.setAttribute('aria-expanded', 'false');
                subMenu.setAttribute('aria-hidden', 'true');
                subMenu.setAttribute('hidden', 'hidden');

            });

        });

        document.addEventListener('keydown', (event) => {

            if (event.key !== 'Escape') {
                return;
            }

            this.closeAllSubMenus();

        });

    }

    closeAllSubMenus(menuItem = false) {

        this.menuItems.forEach((item) => {

            const button = item.children[1];
            const subMenu = item.children[2];

            if ((menuItem !== false && item.contains(menuItem)) || !button || !subMenu) {
                return;
            }

            button.setAttribute('aria-expanded', 'false');
            subMenu.setAttribute('aria-hidden', 'true');
            subMenu.setAttribute('hidden', 'hidden');

        });
    }

    toggleMenu(open = null) {

        const menu = this.rootEl.querySelector('.navigation__responsive-menu');
        const expanded = (open != null) ? open : this.toggleNode.getAttribute('aria-expanded') === 'true';

        if (menu) {

            if (expanded) {

                this.toggleNode.setAttribute('aria-expanded', 'false');
                menu.setAttribute('aria-hidden', 'true');
                menu.setAttribute('hidden', 'hidden');

                if (this.focusContainer) {
                    this.focusContainer.active = false;
                }

                document.documentElement.style.overflow = 'initial';

            } else {

                this.toggleNode.setAttribute('aria-expanded', 'true');
                menu.setAttribute('aria-hidden', 'false');
                menu.removeAttribute('hidden');

                if (this.focusContainer) {
                    this.focusContainer.active = true;
                }

                const mq = window.matchMedia(`(min-width: ${window.breakpoint}px)`).matches;
                if (!mq) {
                    document.documentElement.style.overflow = 'hidden';
                }

            }

        }

    }

    checkBreakpoint() {

        const mq = window.matchMedia(`(min-width: ${window.breakpoint}px)`).matches;

        if (!mq === this.responsive) {
            return;
        }
        this.responsive = !mq;

        const menu = this.rootEl.querySelector('.navigation__responsive-menu');
        if (menu) {

            if (mq) {

                this.toggleMenu(false);
                this.rootEl.parentElement.classList.remove('--responsive');

                if (this.focusContainer) {
                    this.focusContainer.active = false;
                }

            } else {

                this.toggleMenu(true);
                this.rootEl.parentElement.classList.add('--responsive');

                if (!this.focusContainer) {
                    this.focusContainer = new Draad_Focus_Trap(this.rootEl);
                }

                if (this.focusContainer) {
                    this.focusContainer.active = false;
                }

            }

        }

    }

}

(function () {

    document.addEventListener('DOMContentLoaded', () => {
		const value = ( window.scrollY / 200 >= 1 ) ? 1 : window.scrollY / 200;

		document.body.style.setProperty(
			"--scroll",
			value
		);

		if ( value >= 1 ) {
			document.querySelector( '.navigation' ).classList.add( "--scrolled" );
		} else {
			document.querySelector( '.navigation' ).classList.remove( "--scrolled" );
		}

        window.breakpoint = window.breakpoint || 768;

        const nav = document.getElementById('site-navigation');
        if (nav) {
            new Draad_Nav_Menu(nav);
        }

    });

	window.addEventListener( "scroll", () => {
		const value = ( window.scrollY / 200 >= 1 ) ? 1 : window.scrollY / 200;

		document.body.style.setProperty(
			"--scroll",
			value
		);

		if ( value >= 1 ) {
			document.querySelector( '.navigation' ).classList.add( "--scrolled" );
		} else {
			document.querySelector( '.navigation' ).classList.remove( "--scrolled" );
		}

	}, false );

})();